import axios from 'axios'
import global from '@/global/variable.js'

// 获取排队列表
export function getList(data) {
  const url = global.requestUrl + '/truckQueue/list'
  return axios.get(url)
}

// 添加排队信息
export function createOne(data) {
  const url = global.requestUrl + '/truckQueue/insert'
  return axios.post(url, data)
}

// 更新排队信息
export function updateOne(data) {
  const url = global.requestUrl + '/truckQueue/jump'
  return axios.post(url, data)
}

// 删除排队信息
export function deleteOne(data) {
  const url = global.requestUrl + '/truckQueue/delete?plateNumber=' + data.plateNumber
  return axios.get(url)
}
